"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _GenericErrorPage = _interopRequireDefault(require("./GenericErrorPage.style"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var GenericErrorPage = function GenericErrorPage(_ref) {
  var children = _ref.children,
    className = _ref.className;
  return /*#__PURE__*/_react["default"].createElement(_GenericErrorPage["default"], {
    className: className
  }, children);
};
GenericErrorPage.defaultProps = {
  className: 'error-page'
};
GenericErrorPage.propTypes = {
  children: _propTypes["default"].node.isRequired,
  className: _propTypes["default"].string
};
var _default = exports["default"] = GenericErrorPage;